import { getJobCatTransTypeString } from '@api/Trinium/Endpoints/Dispatch/types';
import { ParsedDate, parseIsoDate } from '@api/Trinium/types';

interface StreetTurnRaw {
	chassisId: string;
	cntrId: string;
	cntrProviderName: string;
	cntrSize: string;
	cntrType: string;
	csnCustRefNo: string;
	csnDelvId: string;
	csnId: number;
	csnNo: number;
	csnPuId: string;
	delvCity: string;
	delvId: string;
	delvName: string;
	delvState: string;
	drvId?: string;
	drvName?: string;
	drvType?: string;
	tractorId?: number;
	fclDelvDate: string;
	fclLegNo: number;
	fclLegType: string;
	isLive: boolean;
	isHazmat: boolean;
	isOverweight: boolean;
	isBulk: boolean;
	jobCatTransType?: string;
	jobId: number;
	legId: number;
	legNo: number;
	legStatus: string;
	legType: string;
	puCity?: string;
	puDate: string;
	puId: string;
	puName: string;
	puState?: string;
	schdPuFrom?: string;
	schdPuTo?: string;
	schdDelvFrom?: string;
	schdDelvTo?: string;
}

type ExcludedStreetTurnRawFields = 'jobCatTransType' | 'schdPuFrom' | 'schdPuTo' | 'schdDelvFrom' | 'schdDelvTo';

export type StreetTurn = StreetTurnRaw &
	Omit<StreetTurnRaw, ExcludedStreetTurnRawFields> & {
		jobCategoryTransportationType: string;
		scheduledDeliveryDateFrom: ParsedDate | undefined;
		scheduledDeliveryDateTo: ParsedDate | undefined;
		fclDeliveryDate: ParsedDate | undefined;
	};

export function transformStreetTurnResponse(streetTurn: StreetTurnRaw[]) {
	return streetTurn.map((st) => {
		return {
			jobCategoryTransportationType: getJobCatTransTypeString(st.jobCatTransType),
			scheduledDeliveryDateFrom: parseIsoDate(st.schdDelvFrom),
			scheduledDeliveryDateTo: parseIsoDate(st.schdDelvTo),
			fclDeliveryDate: parseIsoDate(st.fclDelvDate),
			...st
		} as StreetTurn;
	});
}

export interface PutStreetTurnRequest {
	terminalNumber: string;
	legId: number;
	actionType: PutStreetTurnAction;
}

export type PutStreetTurnAction = PerformStreetTurnAction;

interface PerformStreetTurnAction {
	action: 'performStreetTurn';
	data: {
		importLegId: number;
	};
}
